import React from "react"

const DeurenLogo = ({ className = "" }) => (
  <svg
    width="100"
    height="25"
    viewBox="0 0 100 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <style type="text/css">{`
      .st0 {
        fill: #1D1D1B;
      }

      .logo-badge {
        transition: all 0.5s ease-in-out;
        transform: translateX(-2px) scale(1.1);
        transform-origin: left center;
      }

      .logo-lettering {
        transform: translateX(0px) translateZ(0);
        transition: opacity 0.3s ease-in-out;
        transition-delay: 400ms;
      }

      .letter-1,
      .letter-2,
      .letter-3,
      .letter-4,
      .letter-5,
      .letter-6 {
        transition: all 0.3s ease-in-out;
      }

      .letter-1 { transition-delay: 500ms; }
      .letter-2 { transition-delay: 600ms; }
      .letter-3 { transition-delay: 700ms; }
      .letter-4 { transition-delay: 800ms; }
      .letter-5 { transition-delay: 900ms; }
      .letter-6 { transition-delay: 1000ms; }

      .animate .letter-1,
      .animate .letter-2,
      .animate .letter-3,
      .animate .letter-4,
      .animate .letter-5,
      .animate .letter-6 {
        opacity: 0;
        transition-delay: 0ms;
      }

      .animate .logo-lettering {
        transform: translateX(128px) translateZ(0);
        opacity: 0;
        transition-delay: 0ms;
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
      }

      .animate .logo-badge {
        transform: translateX(41px) scale(1.1);
      }
    `}</style>
    <g className="logo-badge" clipPath="url(#clip0_1632_541)">
      <path d="M9.88851 3.86044L10.2245 0.691326L9.12611 1.75739C9.31994 1.87369 9.44916 2.0869 9.44916 2.32919C9.44916 2.69746 9.14873 2.9979 8.78045 2.9979C8.41218 2.9979 8.10851 2.69746 8.10851 2.32919C8.10851 2.02875 8.3088 1.77677 8.58016 1.69278L7.5141 0L6.4448 1.69278C6.71293 1.78 6.90999 2.02875 6.90999 2.32919C6.90999 2.69746 6.60956 2.9979 6.24128 2.9979C5.87301 2.9979 5.57257 2.69746 5.57257 2.32919C5.57257 2.0869 5.70502 1.87369 5.89885 1.75739L4.80371 0.691326L5.13968 3.86367C5.87301 3.72153 6.67094 3.63108 7.52702 3.63108C8.3831 3.63108 9.16165 3.7183 9.88851 3.86044Z" className="st0" />
      <path d="M9.32324 4.86189V9.98869L13.1255 6.1864C12.1758 5.65013 10.8965 5.11387 9.32324 4.86189Z" className="st0" />
      <path d="M5.70527 23.2143V18.7272L3.0498 21.3827C3.95111 22.1515 4.90734 22.7653 5.70527 23.2143Z" className="st0" />
      <path d="M0 12.5505H3.1465L0 9.40398V12.5505Z" className="st0" />
      <path d="M5.70494 4.86189C4.12846 5.11387 2.84595 5.65013 1.89941 6.1864L5.70494 9.99192V4.86189Z" className="st0" />
      <path d="M3.14654 16.1686H0.0258789C0.0743363 17.0441 0.319854 17.8582 0.713975 18.6012L3.14654 16.1686Z" className="st0" />
      <path d="M15.0025 16.1686H11.8818L14.3112 18.598C14.7085 17.855 14.9508 17.0409 15.0025 16.1686Z" className="st0" />
      <path d="M11.9757 21.3794L9.32666 18.7272V23.2111C10.1214 22.7588 11.0744 22.1451 11.9757 21.3794Z" className="st0" />
      <path d="M15.0283 9.40398L11.8818 12.5505H15.0283V9.40398Z" className="st0" />
      <path d="M8.3896 16.4755L12.6635 20.7495C13.0803 20.3392 13.4679 19.8934 13.8039 19.4121L9.63011 15.235H15.0283V13.4841H9.62688L15.0283 8.08594V7.55937C15.0283 7.55937 14.6438 7.17817 13.9396 6.69359L8.3896 12.2436V4.77468C8.09885 4.75206 7.82103 4.71007 7.5109 4.71007C7.20078 4.71007 6.92618 4.75206 6.63544 4.77468V12.2436L1.08545 6.69036C0.381198 7.17494 0 7.55613 0 7.55613V8.08271L5.40139 13.4809H0V15.2318H5.40139L1.22113 19.4121C1.56033 19.8902 1.94799 20.3392 2.36149 20.7495L6.63867 16.4723V23.7086C7.16847 23.9703 7.51413 24.1157 7.51413 24.1157C7.51413 24.1157 7.86303 23.9703 8.39283 23.7054V16.4723L8.3896 16.4755Z" className="st0" />
    </g>
    <g className="logo-lettering">
      <g className="letter-1">
        <path d="M26.322 8.67388H28.9258C31.6782 8.67388 33.6003 10.5088 33.6003 13.1352V13.1675C33.6003 15.7745 31.6782 17.5965 28.9258 17.5965H26.322V8.67388V8.67388ZM28.9258 7.29768H24.8457V18.9727H28.9258C32.5181 18.9727 35.1251 16.5175 35.1251 13.1352V13.1029C35.1251 9.73994 32.5181 7.29768 28.9258 7.29768Z" className="st0" />
      </g>
      <g className="letter-2">
        <path d="M39.6899 13.7651H45.9635V12.4051H39.6899V8.65772H46.7033V7.29768H38.2168V18.9727H46.7873V17.6127H39.6899V13.7651Z" className="st0" />
      </g>
      <g className="letter-3">
        <path d="M58.9274 14.072C58.9274 16.4271 57.6966 17.7774 55.5515 17.7774C53.4065 17.7774 52.1272 16.398 52.1272 13.9913V7.30092H50.6509V14.0753C50.6509 17.2573 52.4697 19.1568 55.5192 19.1568C58.5688 19.1568 60.4037 17.2218 60.4037 13.9784V7.30415H58.9274V14.072Z" className="st0" />
      </g>
      <g className="letter-4">
        <path d="M65.9021 8.67388H69.362C71.1484 8.67388 72.2113 9.48796 72.2113 10.8512V10.8835C72.2113 12.2662 71.0871 13.161 69.3426 13.161H65.8989V8.67388H65.9021ZM73.7038 10.8351V10.8028C73.7038 9.88854 73.3807 9.06476 72.7895 8.47358C72.0304 7.71442 70.848 7.29768 69.4589 7.29768H64.4258V18.9727H65.8989V14.5049H69.0519L72.3857 18.9727H74.2013L70.6477 14.2465C72.5892 13.8459 73.7005 12.6086 73.7005 10.8351Z" className="st0" />
      </g>
      <g className="letter-5">
        <path d="M79.1181 13.7651H85.3917V12.4051H79.1181V8.65772H86.1315V7.29768H77.645V18.9727H86.2155V17.6127H79.1181V13.7651Z" className="st0" />
      </g>
      <g className="letter-6">
        <path d="M98.559 7.29768V16.3431L91.4487 7.29768H90.1016V18.9727H91.5424V9.71086L98.8336 18.9727H99.9998V7.29768H98.559Z" className="st0" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1632_541">
        <rect width="100" height="24.1157" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default DeurenLogo
